import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let roeworkPermitDraftPageMachine: any;

const MODULE_NAME = 'machines.roeworkPermitDraft';
const log: any = LoggerModule?.getInstance();

export const useSMroeworkPermitDraftPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  roeworkPermitDraftPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(roeworkPermitDraftPageMachine);

  return {
    roeworkPermitDraftPageMachine,
    roeworkPermitDraftPageState: state,
    roeworkPermitDraftPageSend: send,
  };
};
